module.exports = __webpack_public_path__ + "img/mobile-services-outline.0960bec1.svg";